import React from 'react'
import SearchForm from '../SearchForm'
import SubmitInquiry from '../submitInquiry/SubmitInquiry'
import history from '../../history'
import { PERMISSIONS } from '../../constants'

const HomeContentProfessional = ({permissions, messageItems, _showNotification}) => {

    const onSearchSubmit = (postData) => {
        history.push('/search', postData)
    }

    return (
        <React.Fragment>
            <div className='row search-container'>
                <div className='col widget-mb-0-row'>
                    <div className='container'>
                        {
                            permissions.indexOf(PERMISSIONS.SEARCH) !== -1 &&
                            <SearchForm submit={onSearchSubmit} _showNotification={_showNotification}/>
                        }
                    </div>
                </div>
            </div>
            <div className='row mb-3 mr-0'>
                <div className='col widget-mb-0-row p-0'>
                    <div className='container'>
                        <SubmitInquiry embedded='true' flowType='MI_PORTAL_REQUEST' messageItems={messageItems}/>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default HomeContentProfessional;


// WEBPACK FOOTER //
// ./src/mi-app/home/HomeContentProfessional.js